import * as u from '../utils';
import Flickity from 'flickity';
import imagesloaded from 'flickity-imagesloaded'; // eslint-disable-line no-unused-vars

export default () => {
    const gallery = document.querySelector('.woocommerce-product-gallery__wrapper');

    if (!gallery) {
        return;
    }

    if (gallery.children.length > 1) {
        new Flickity(gallery, {
            cellAlign: 'cenrter', // TODO - locate and see if this needs removing / fixing
            prevNextButtons: false,
            pageDots: true,
            wrapAround: true,
        });
    } else {
        u.addClass(gallery, 'woocommerce-product-gallery__wrapper--no-slider');
    }
};
